
import React from 'react';
import {Col, FormGroup, Label, Row} from "reactstrap";

const removeKey = (k, { [k]:_, ...o }) => o;

function Likert({ value, onChange }) {
    return <div className="likert">
        <div>
        { [...Array(5)]
            .fill(0)
            .map((_,i) => i + 1)
            .map(a => <span key={a} className={value === a ? 'active' : ''} onClick={() => onChange( value === a ? null : a)}>
                { a }
            </span>)
        }
        </div>
        <div>
            <span>Zero Experience</span>
            <span>Skilled</span>
            <span>Expert</span>
        </div>
    </div>
}

const SelfAsses = React.memo(function({ value, onChange, fields }) {
    value = value || {};

    return <Row>
        { fields.map(a => <Col md="6" key={a.id}>
            <FormGroup>
                <Label><b>{ a.name }</b></Label>
                <Likert value={value[a.id]} onChange={val => onChange(val ? { ...value, [a.id]: val} : removeKey(a.id, value))} />
            </FormGroup>
        </Col>) }
    </Row>
}, (oldProps, newProps) => oldProps.value === newProps.value);


export default SelfAsses;